import React, { useState } from "react";
import {
  FaEnvelope,
  FaFacebookF,
  FaWhatsapp,
  FaCopy,
  FaShareAlt,
  FaArrowCircleLeft,
} from "react-icons/fa";
import "../style/SocialMedia.css";

const SocialMedia = ({ site }) => {
  const [showShareOptions, setShowShareOptions] = useState(false);

  const shareViaEmail = () => {
    if (!site || !site.emailContent) return;
    const url = window.location.href;
    const subject = encodeURIComponent(site.emailContent.subject);
    const body = encodeURIComponent(`${site.emailContent.body} ${url}`);

    console.log("Email Subject:", subject);
    console.log("Email Body:", body);

    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  };

  const shareOnWhatsApp = () => {
    console.log("Attempting to share on WhatsApp...");

    if (!site) {
      console.log("Current site not set.");
      return;
    }

    const url = window.location.href;
    const message = encodeURIComponent(
      `Experience the joy of discovery with ${site.siteName}, brought to you by Happy Nenapu . Explore the wonder within every page, and share the magic with friends! ${url}`
    );

    console.log("WhatsApp Message:", message);

    window.open(`whatsapp://send?text=${message}`);
  };

  const copyLinkToClipboard = () => {
    const url = window.location.href;
    navigator.clipboard
      .writeText(url)
      .then(() => {
        console.log("Link copied to clipboard:", url);
        alert("Link copied to clipboard!");
      })
      .catch((error) => {
        console.error("Failed to copy:", error);
      });
  };

  const shareOnFacebook = () => {
    const url = window.location.href;
    console.log("Facebook Share URL:", url);

    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      "_blank"
    );
  };

  const toggleShareOptions = () => {
    setShowShareOptions(!showShareOptions);
  };

  const backToIndex = () => {
    if (site && site.backToIndexLink) {
      console.log("Back to Index Link:", site.backToIndexLink);
      window.location.href = site.backToIndexLink;
    }
  };

  return (
    <div className="social-media-share">
      <button
        className="share-button"
        onClick={toggleShareOptions}
        title="Share Link"
      >
        <FaShareAlt size={20} />
      </button>
      <div className={`share-options ${showShareOptions ? "show" : ""}`}>
        <button
          className="share-option email"
          onClick={shareViaEmail}
          title="Share via Email"
        >
          <FaEnvelope size={20} />
        </button>
        <button
          className="share-option facebook"
          onClick={shareOnFacebook}
          title="Share on Facebook"
        >
          <FaFacebookF size={20} />
        </button>
        <button
          className="share-option whatsapp"
          onClick={shareOnWhatsApp}
          title="Share on WhatsApp"
        >
          <FaWhatsapp size={20} />
        </button>
        <button
          className="share-option copy"
          onClick={copyLinkToClipboard}
          title="Copy Link"
        >
          <FaCopy size={20} />
        </button>
      </div>
      <button
        className="back-to-index rounded-icon "
        onClick={backToIndex}
        title="Go Back to Index"
      >
        <FaArrowCircleLeft size={20} />
      </button>
    </div>
  );
};

export default SocialMedia;
